import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Form, Image, Upload } from "antd";
import get from "lodash/get";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const UploadImg = ({ form, logo }) => {
  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList, file }) => {
    setFileList(newFileList);

    if (file.status === "done") {
      form.setFieldsValue({
        logo: get(file, "response.data.key"),
      });
    } else if (file.status === "error") {
      console.error("File upload failed:", get(file, "response"));
    }
  };

  const uploadButton = (
    <div className="flex items-center justify-center h-full">
      <PlusOutlined />
      <br />
      <div>Upload</div>
    </div>
  );

  useEffect(() => {
    if (logo) {
      setFileList([
        {
          uid: "-1",
          name: get(logo, "key"),
          status: "done",
          url: `${get(logo, "url")}`,
        },
      ]);
    }
  }, [logo]);

  return (
    <Form.Item
    label='Upload logo'
    name="logo"
    rules={[
      {
        required: true,
        message: "Please select Company logo...!",
      },
        ]}
        >
        <div>
        <Upload
          action="https://staging.api.sochiot.visao.io/api/v1/media?file"
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          onChange={handleChange}
        >
          {fileList.length >= 1 ? null : uploadButton}
        </Upload>

        {previewImage && (
          <Image
            wrapperStyle={{
              display: "none",
            }}
            preview={{
              visible: previewOpen,
              onVisibleChange: (visible) => setPreviewOpen(visible),
              afterOpenChange: (visible) => !visible && setPreviewImage(""),
            }}
            src={previewImage}
          />
        )}
    </div>
      </Form.Item>
  );
};

export default UploadImg;
